import { UserService } from 'src/app/core/services/user.services';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PaymentsService } from '../../core/services/payments.service';
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
import { MatSelect } from '@angular/material/select';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { IdentityService } from '../../core/services/identity.service';
import * as svg from 'save-svg-as-png';
import html2pdf from 'html2pdf.js';

import { Router } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-user-qr',
  templateUrl: './user-qr.component.html',
  styleUrls: ['./user-qr.component.scss']
})
export class UserQrComponent implements OnInit {
  @ViewChild('branchSelect') branchSelect: MatSelect;
  @ViewChild('userQRCont', { static: true }) userQRCont: ElementRef;
  @ViewChild('pdfContent') pdfContent: ElementRef;
  @ViewChild('myTooltip') myInfoTooltip: MatTooltip;

  qrGenerator: BrowserQRCodeSvgWriter;

  buttonImprimir: boolean = true;

  qrForm: UntypedFormGroup;

  name: string = '';

  cuilCuit: string = '';

  domicilio: string = '';

  branchName: string = '';

  public commerceUser: boolean;
  public userResponsible: boolean;

  public QRimgSrc: string = '';

  public spinnerDownload: boolean = false;

  //#region DATA-BRANCH-OFFICES
  branchOfficesCollection: SimpleSelect[];
  set branchOffice(branch: SimpleSelect) {
    document.getElementById('userQR').innerHTML = '';
    this.generateQR(branch.value);
  }

  //#endregion DATA-BRANCH-OFFICES

  constructor(
    private paymentsService: PaymentsService,
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private identity: IdentityService,
    private router: Router
  ) {
    this.qrGenerator = new BrowserQRCodeSvgWriter();
    this.branchOfficesCollection = new Array<SimpleSelect>();
    this.commerceUser = false;
    this.userResponsible = false;
  }

  ngOnInit() {
    this.userService.showSaldo = false;
    this.commerceUser = this.identity.isCommerce();
    this.userResponsible = this.identity.isRolResponsible();

    this.name = this.identity.isCommerce()
      ? this.identity.getUser().organismo.nombre
      : `${this.identity.getUser().persona.nombres} ${this.identity.getUser().persona.apellido}`;

    this.cuilCuit = this.identity.isCommerce()
      ? this.identity.getUser().organismo.numeroDocumento
      : (this.cuilCuit = this.identity.getUser().persona.cuilCuit);

    if (!this.commerceUser && !this.userResponsible) {
      this.generateQR();
    } else {
      // Form sucursales
      this.qrForm = this.fb.group({
        branchOffice: [null, Validators.required]
      });
      // Sucursales
      this.userService.getBranchOfficesCollection().then((officeBranches) => {
        officeBranches.forEach((ob) => {
          const opt = { value: ob.id, display: ob.name };
          this.branchOfficesCollection.push(opt);
          if (ob.isMainOffice() && !this.userResponsible) {
            this.qrForm.get('branchOffice').setValue(opt);
          }
        });
        this.generateQR(this.branchOfficesCollection[0].value);
        if (this.userResponsible && this.branchOfficesCollection.length > 0) {
          this.qrForm.get('branchOffice').setValue(this.branchOfficesCollection[0]);
          this.generateQR(this.branchOfficesCollection[0].value);
        }
      });
    }
  }

  async setInfoQr(sucursalId: number) {
    let sucursal = await this.userService.getBranchOfficesCollection();

    var branch = sucursal.filter((sucursal) => sucursal.id == sucursalId)[0];

    this.branchName = branch.name !== null ? branch.name : ' - ';

    this.domicilio =
      branch.address !== null ? branch.address : this.identity.getUser().organismo.ubicacion.nombreDireccion;
  }

  completeProfile = false;

  async generateQR(sucursalId: number = 0) {
    this.QRimgSrc = '';
    this.setInfoQr(sucursalId);
    try {
      document.getElementById('userQR').innerHTML = '';
      const qrResponse = await this.paymentsService.getQREMVco(sucursalId);
      if (qrResponse) {
        this.buttonImprimir = false;
        this.qrGenerator.writeToDom('#userQR', qrResponse, 380, 380);
        this.QRimgSrc = await svg.svgAsPngUri(this.userQRCont.nativeElement.children[0], { backgroundColor: 'white' });
      } else {
        this.buttonImprimir = true;
      }
    } catch (error) {
      this.buttonImprimir = true;
      if (error.message == 'Debe completar su perfil para generar un QR.') {
        this.completeProfile = true;
      }
    }
  }
  printQR(): void {
    window.print();
  }

  goBack() {
    let lastUrl = localStorage.getItem('url');
    this.router.navigate([lastUrl]);
  }

  async downloadQR() {
    this.spinnerDownload = true;
    const myBranch = this.qrForm.get('branchOffice').value;
    const element = this.pdfContent.nativeElement;
    try {
      const canvas = await html2canvas(element, {
        scale: 1,
        logging: true,
        useCORS: true
      });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('landscape', 'mm', 'a4');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth - 20, pdfHeight - 20);
      const dataUrl = pdf.output('datauristring');
      this.triggerDataDownload(dataUrl, `QR-${myBranch.display}.pdf`);
    } finally {
      this.spinnerDownload = false;
    }
  }

  private triggerDataDownload(dataUrl: string, filename: string) {
    const isData = typeof dataUrl === 'string' && dataUrl.startsWith('data:');
    const isBase64 = typeof dataUrl === 'string' && dataUrl.includes(';base64,');
    console.log(
      '[triggerDataDownload] isData:',
      isData,
      'isBase64:',
      isBase64,
      'preview:',
      isData ? dataUrl.slice(0, 80) + '…' : String(dataUrl)
    );
    const anchor = document.createElement('a');
    anchor.href = dataUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
}

interface SimpleSelect {
  value: number;
  display: string;
}
